import { IModel } from "@/@types/models/model";

import { coreFields} from "./helpers/coreFields";

const Dio: IModel = {
  title: "Dijelovi",
  apiPath: "operations/objekti/{objekt_id}/katovi/{kat_id}/dijelovi",
  forms : {
    "default": {
      fields: ["id", "broj_dijela", "namjena_id", "pre_pt", "pre_pb", "pre_pn", "pre_pn_jls"]
    },
    "admin": {
      fields: ["id", "broj_dijela", "namjena_id", "pre_pt", "pre_pb", 'pre_pn', "pre_pn_jls"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "broj_dijela", "namjena_id", "pre_pt", "pre_pb", "pre_pn", "pre_pn_jls"],
      hidden: ["id" ]
    },
    "admin": {
      fields: ["id", "broj_dijela", "namjena_id", "pre_pt", "pre_pb", "pre_pn", "pre_pn_jls"],
      hidden: ["id" ]
    }
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    coreFields.modified_on,
    {
      title: "Object ID",
      source: "objekti_id",
      ttoken: "common.objectid",
      type: "numeric",
      readonly: true
    },
    {
      title: "Dio ID",
      source: "dijelovi_id",
      ttoken: "common.id",
      type: "numeric",
      readonly: true
    },
    {
      title: "Kat ID",
      source: "kat_id",
      ttoken: "dijelovi.kat_id",
      type: "numeric",
      readonly: true
    },
    {
      title: "Etaza ID",
      source: "etaza_id",
      ttoken: "dijelovi.etaza_id",
      type: "numeric",
      readonly: true
    },
    {
      title: "Etaza Broj",
      source: "etaza_broj",
      ttoken: "dijelovi.etaza",
      type: "numeric",
      readonly: true
    },
    {
      title: "Dio Broj",
      source: "broj_dijela",
      ttoken: "dijelovi.dio",
      type: "numeric"
    },
    {
      title: "Namjena ID",
      source: "xxnamjena_id",
      ttoken: "dijelovi.namjena_id",
      type: "numeric",
      readonly: true
    },
    {
      title: "Namjena ID",
      source: "namjena_id",
      ttoken: "dijelovi.namjena_id",
      type: "buttonGroup",
      items: {
        labels: ['S', 'P', 'G', 'B', 'K', 'J', 'A', 'O', 'T', 'Z', 'F', 'N'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

      },
      rowWidth: 6
    },
    {
      title: "Broj dijela",
      source: "broj_dijela",
      ttoken: "dijelovi.broj_dijela",
      type: "numeric",
      readonly: true
    },
    {
      title: "Pre PB",
      source: "pre_pb",
      ttoken: "dijelovi.pre_pb",
      type: "numeric",
      selectAll: true,
      validation: {
        required: true,
        minValue: 0
      }
    },
    {
      title: "Pre Pt",
      source: "pre_pt",
      ttoken: "common.pre_pt",
      type: "numeric",
      readonly: true
    },
    {
      title: "Pre Pn",
      source: "pre_pn",
      ttoken: "common.pre_pn",
      type: "numeric",
      calculated: true
    },
    {
      title: "Pre PN JLS",
      source: "pre_pn_jls",
      ttoken: "dijelovi.pre_pn_jls",
      type: "numeric",
      readonly: true
    },
    {
      title: "Izvor P",
      source: "izvor_p",
      ttoken: "common.izvor_p",
      type: "text",
      readonly: true
    },
    {
      title: "",
      source: "cancel",
      ttoken: "",
      tooltip: "buttons.cancel",
      type: "button",
      icon: "cancel",
      action: "cancel",
      padding: "none",
      sort: false
    }
  ]
}

export default Dio;
